<template>
  <table class="tw-w-full tw-relative" style="border-spacing: 0 0.25rem">
    <thead class="tw-table-header-group">
      <tr>
        <th
          v-for="thIndex in cols"
          :key="thIndex"
          class="tw-h-10 tw-px-4 tw-space-x-1.5 tw-whitespace-nowrap"
          :class="
            thIndex === 1 ? 'tw-hidden sm:tw-table-cell' : 'tw-table-cell'
          "
        >
          <div
            class="tw-flex"
            :class="thIndex === cols ? 'tw-justify-end' : 'tw-justify-center'"
          >
            <loading-label />
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="tdindex in rows"
        :key="tdindex"
        class="tw-table-row tw-h-15 tw-border-transparent mod-button-transition tw-group tw-p-0 tw-pr-2 tw-relative"
      >
        <td
          v-for="index in cols"
          :key="index"
          class="tw-px-4 tw-py-0 tw-align-middle tw-relative tw-h-9"
          :class="index === 1 ? 'tw-hidden sm:tw-table-cell' : 'tw-table-cell'"
        >
          <div
            class="tw-flex"
            :class="index === cols ? 'tw-justify-end' : 'tw-justify-center'"
          >
            <loading-label />
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <div v-if="hasError" class="tw-flex tw-flex-col tw-mt-2 tw-space-y-1">
    <base-input-errors :errors="errorText" align="left" size="sm" />
  </div>
</template>

<script>
import LoadingLabel from '@components/Loading/LoadingLabel.vue'
export default {
  components: {
    LoadingLabel,
  },
  props: {
    rows: {
      type: Number,
      default: 6,
    },
    cols: {
      type: Number,
      default: 4,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: 'There has been a problem loading the data',
    },
  },
  setup() {
    const sizes = ['1', '2', '3']

    function isOdd(num) {
      return num % 2
    }

    function twSize() {
      let obj = sizes[Math.floor(Math.random() * sizes.length)]
      if (obj === '1') {
        return 'tw-w-3/6'
      } else if (obj === '2') {
        return 'tw-w-2/6'
      } else {
        return 'tw-w-2/5'
      }
    }

    return {
      twSize,
      isOdd,
    }
  },
}
</script>
